module.exports = __webpack_public_path__ + "media/images/icons/paperclip-967f08eacaa7337df9c05626d9a548af.svg";